import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropertySearch from '../components/PropertySearch';

const HomePage = () => {
  const navigate = useNavigate();

  const handleSearch = (filters) => {
    const queryParams = new URLSearchParams();
    
    if (filters.location) queryParams.append('location', filters.location);
    if (filters.minPrice) queryParams.append('minPrice', filters.minPrice);
    if (filters.maxPrice) queryParams.append('maxPrice', filters.maxPrice);
    if (filters.bedrooms) queryParams.append('bedrooms', filters.bedrooms);
    
    navigate(`/nekretnine?${queryParams.toString()}`);
  };

  return (
    <div style={styles.container}>
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          <h1 style={styles.heroTitle}>Pronađite savršenu nekretninu</h1>
          <p style={styles.heroSubtitle}>Pretražite našu bazu nekretnina po vašim kriterijima</p>
          <PropertySearch onSearch={handleSearch} />
        </div>
      </section>
      
      <section style={styles.featuredSection}>
        <div style={styles.sectionHeader}>
          <h2>Izdvojeni oglasi</h2>
        </div>
        
        <div style={styles.featuredGrid}>
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🏠</div>
            <h3>Širok izbor</h3>
            <p>Na tisuće nekretnina za svaki ukus i budžet</p>
          </div>
          
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>💰</div>
            <h3>Najbolje cijene</h3>
            <p>Konkurentne tržišne cijene i povoljni uvjeti</p>
          </div>
          
          <div style={styles.featureCard}>
            <div style={styles.featureIcon}>🔑</div>
            <h3>Brza realizacija</h3>
            <p>Ubrzani procesi i brze transakcije</p>
          </div>
        </div>
      </section>
    </div>
  );
};

const styles = {
  container: {
    paddingBottom: '3rem'
  },
  hero: {
    backgroundImage: 'linear-gradient(rgba(0,0,0,0.5), url(https://images.unsplash.com/photo-1564013799919-ab600027ffc6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: 'white',
    padding: '5rem 1rem',
    textAlign: 'center'
  },
  heroContent: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  heroTitle: {
    fontSize: '3rem',
    marginBottom: '1rem',
    color: 'black'
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    marginBottom: '2rem',
    color: 'black'
  },
  featuredSection: {
    padding: '3rem 0',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  sectionHeader: {
    textAlign: 'center',
    marginBottom: '2rem'
  },
  featuredGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem'
  },
  featureCard: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
    textAlign: 'center',
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)'
    }
  },
  featureIcon: {
    fontSize: '3rem',
    marginBottom: '1rem'
  }
};

export default HomePage;